const Immutable = require('immutable')
const createRow = require('../createRow')
const TablePosition = require('../TablePosition')

/**
 * Insert a new row in current table
 *
 * @param {Object} opts
 * @param {Slate.Transform} transform
 * @param {Number} at
 * @param {Function} textGetter
 * @return {Slate.Transform}
 */
function insertAccordionRow (opts, transform, at, textGetter) {
  const { state } = transform
  const { startBlock } = state

  const pos = TablePosition.create(state, startBlock, opts)
  const { table } = pos

    // Create a new row with the right count of cells
  const firstRow = table.nodes.get(0)
  const columns = firstRow.nodes.size
  const currentRow = table.nodes.get(pos.getRowIndex())
  const rowPair = Immutable.Range(0, 2)
        .map(i =>
          createRow(opts, columns,
            textGetter ? textGetter.bind(null, i) : null,
            { isAccordionTitle: !i }
          )
        )

  if (typeof at === 'undefined') {
    at = pos.getRowIndex() + 1
    if (currentRow.data.get('isAccordionTitle')) {
      // skip content row
      at += 1
    }
  }

  transform
    // to trigger tooltip to disappear
    .setNodeByKey(currentRow.key, {data: {isFocused: false}})

  transform = rowPair.reduce((t, child) => {
    return t.insertNodeByKey(table.key, at, child)
  }, transform)

  return transform
    .focus()
}

module.exports = insertAccordionRow



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/deep-table-plugin/transforms/insertAccordionRow.js